/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum PaymentMethodStatusEnum {
  "ENABLED" = "ENABLED",

  "DISABLED" = "DISABLED",

  "INCOMING" = "INCOMING"
}

/**
 * Payment method status
 */

export type PaymentMethodStatus = t.TypeOf<typeof PaymentMethodStatus>;
export const PaymentMethodStatus = enumType<PaymentMethodStatusEnum>(
  PaymentMethodStatusEnum,
  "PaymentMethodStatus"
);
